import { Fragment } from 'react';
import styles from './UpChevron.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { XMLNS } from '@shopify/polaris-viz-core';

function UpChevron({
  accessibilityLabel,
  fill
}) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      className: styles.VisuallyHidden,
      children: accessibilityLabel
    }), /*#__PURE__*/jsx("svg", {
      xmlns: XMLNS,
      "aria-hidden": "true",
      style: {
        fill
      },
      width: "9",
      height: "6",
      viewBox: "0 0 9 6",
      children: /*#__PURE__*/jsx("path", {
        d: "M1.0144 6H7.9856C8.83047 6 9.30374 5.09579 8.78176 4.47887L5.29616 0.359336C4.89077 -0.119779 4.10923 -0.119779 3.70384 0.359336L0.218239 4.47887C-0.30374 5.09579 0.169525 6 1.0144 6Z",
        fill: "#039C86"
      })
    })]
  });
}

export { UpChevron };
